import Vue from "vue";

const user = {
  state: {
    userInfo:{},
  },
  mutations: {
    updateUserInfo(state) {
      Vue.prototype.$func.ajax('getUserInfo',{
        token : Vue.prototype.$func.getToken(),
      },function (r) {
        if(!r.statusCode){
          Vue.prototype.$func.msg(r.message,'error');
        }else{
          state.userInfo = r.type;
        }
      })
    },
    loginOut(state, tips = true) {
      Vue.prototype.$func.loginOut(tips);
    }
  }
};

export default user;
